import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const EbookHeader = ({
    t, breakpoint, scrollToForm, ebook, showShadow
}) => (
    <div className="container-ebook-header" id="container-ebook-header">
        <div className="layout">
            <div className="page-ebook-header" id="page-ebook-header">
                <div className="ebook-header" id="ebook-header">
                    <div className="ebook-header-title" id="ebook-header-title">{ ebook.header.title }</div>
                    <div className="ebook-header-subtitle" id="ebook-header-subtitle">{ ebook.header.subtitle }</div>
                </div>
                <div className="ebook-header-image-container">
                    <div
                      className={ cx('ebook-header-image', { shadow: showShadow }) }
                      id="ebook-header-image"
                      onClick={ scrollToForm }
                    >
                        {
                            (breakpoint === 'widescreen' || breakpoint === 'desktop' || breakpoint === 'laptop') &&
                                <span className="tooltip">{ t('ebook.tooltip') }</span>
                        }
                        <img
                          src={ require(`../../../assets/images/ebook/${ ebook.header.cover.image }`) }
                          alt={ ebook.header.cover.alt }
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

EbookHeader.propTypes = {
    t: PropTypes.func.isRequired,
    breakpoint: PropTypes.string.isRequired,
    scrollToForm: PropTypes.func.isRequired,
    ebook: PropTypes.shape().isRequired,
    showShadow: PropTypes.bool.isRequired
};

export default EbookHeader;



// WEBPACK FOOTER //
// ./src/components/content/ebook/EbookHeader.jsx